export default "__VITE_ASSET__DYdJm_2V__"